import { Navigate, Outlet, useLocation } from 'react-router-dom';

import PageLoader from '@/components/common/page-loader';
import useAuth from '@/hooks/use-auth';
import { APP_ROUTES } from '@/lib/routes/app-routes';

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading, pendingRoleSelection } = useAuth();
  const { pathname } = useLocation();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={APP_ROUTES.login} replace />;
  }

  if (pendingRoleSelection && pathname !== APP_ROUTES.chooseRole) {
    return <Navigate to={APP_ROUTES.chooseRole} replace />;
  }

  // The chooser is reachable only at login; changing context afterwards
  // requires signing out and back in.
  if (!pendingRoleSelection && pathname === APP_ROUTES.chooseRole) {
    return <Navigate to={APP_ROUTES.dashboard} replace />;
  }

  return <Outlet />;
}
